import { render, staticRenderFns } from "./honorar.vue?vue&type=template&id=39bf1761&"
import script from "./honorar.vue?vue&type=script&lang=js&"
export * from "./honorar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports